<div class="er-page er-home">
  <div class="er-card er-home-card">
    <div class="er-empty">
      <div class="er-empty__icon"><i class="fa fa-compass" aria-hidden="true"></i></div>
      <div class="er-empty__title">Welcome back</div>
      <div class="er-empty__msg">Head to your dashboard to see today's numbers, or pick a service from the sidebar.</div>
      <div class="er-empty__action">
        <a class="er-btn er-btn--primary" routerLink="/dashboard">Go to dashboard</a>
      </div>
    </div>
  </div>
</div>
